import EventAdminPortal from './pages/EventAdminPortal'
import EventCheckin from './pages/EventCheckin'
import { useEffect, useState } from 'react'
import FactoryPortal from './pages/FactoryPortal'
import HomePage from './pages/HomePage'
import PlatformPage, { type Role } from './pages/PlatformPage'

function routeFromHash(): { surface: 'home' | 'platform' | 'growth'; role: Role } {
  const hash = window.location.hash.replace('#/', '')
  if (window.location.hostname === 'grow.jiumiqqt.com') return { surface: 'growth', role: 'jiumi' }
  const role = hash.split('/')[1] as Role
  return { surface: hash.startsWith('platform') ? 'platform' : 'home', role: ['jiumi', 'factory', 'sourcing', 'channel'].includes(role) ? role : 'jiumi' }
}

export default function App() {
  const [route, setRoute] = useState(routeFromHash)
  useEffect(() => {
    const onHash = () => setRoute(routeFromHash())
    window.addEventListener('hashchange', onHash)
    return () => window.removeEventListener('hashchange', onHash)
  }, [])

  const openPlatform = (_role: Role) => { window.location.assign('https://grow.jiumiqqt.com/') }
  if (['/crm/checkin/ganzhou-202610','/checkin/ganzhou-202610'].includes(window.location.pathname.replace(/\/$/,''))) return <EventCheckin />
  if (window.location.hostname === 'crm.jiumiqqt.com' || window.location.pathname === '/crm' || window.location.pathname === '/crm/') return <EventAdminPortal />
  if (route.surface === 'growth') return <FactoryPortal />
  if (route.surface === 'platform') return <PlatformPage initialRole={route.role} onHome={() => { window.location.hash = '/' }} />
  return <HomePage onEnter={openPlatform} />
}
